
import React from 'react';
import { ThemeProvider } from 'styled-components';

import { openDialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import { isLocalParticipantModerator } from '../../../base/participants';
import { connect } from '../../../base/redux';
import { AddBreakoutRoomButton } from '../../../breakout-rooms/components/web/AddBreakoutRoomButton';
import { RoomList } from '../../../breakout-rooms/components/web/RoomList';
import { MuteEveryoneDialog } from '../../../video-menu/components/';
import { close } from '../../actions';
import { classList, findStyledAncestor, getParticipantsPaneOpen } from '../../functions';
import theme from '../../theme.json';
import { FooterContextMenu } from './FooterContextMenu';
import {
    getParticipantCountWithFake,
    getSortedParticipantIds
} from '../../../base/participants';
import { getCurrentRoomId, getRooms, isInBreakoutRoom } from '../../../breakout-rooms/functions';

// import { LobbyParticipantList } from './LobbyParticipantList';
import LobbyParticipants from './LobbyParticipants';
import MeetingParticipantList from './RPC_MeetingParticipantList';
import {
    AntiCollapse,
    Close,
    Container,
    Footer,
    FooterButton,
    FooterEllipsisButton,
    FooterEllipsisContainer
} from './styled';

import { ParticipantsPane, _connect } from "./ParticipantsPane";
import Header from './ParticipantsPaneHeader';

class RPC_ParticipantsPane extends ParticipantsPane {

    constructor(props) {
        super(props);
    }
    
    render() {
        const {
            _showAddRoomButton,
            _paneOpen,
            _showFooter,
            currentRoom,
            participantsCount,
            t
        } = this.props;

        // when the pane is not open optimize to not
        // execute the MeetingParticipantList render for large list of participants
        if (!_paneOpen) {
            return null;
        }

        return (
            <ThemeProvider theme = { theme }>
                <div className = { classList('participants_pane', !_paneOpen && 'participants_pane--closed') }>
                    <div className = 'participants_pane-content'>
                        <Header className = 'chat-header' onCancel = { this._onClosePane }/>
                        <Container>
                            {/* <LobbyParticipants /> */}
                            <AntiCollapse />
                            <MeetingParticipantList />
                            <RoomList />
                            {_showAddRoomButton && <AddBreakoutRoomButton />}
                        </Container>
                        {_showFooter && (
                            <Footer>
                                <FooterButton onClick = { this._onMuteAll }>
                                    {t('participantsPane.actions.muteAll')}
                                </FooterButton>
                                <FooterEllipsisContainer>
                                    <FooterEllipsisButton
                                        id = 'participants-pane-context-menu'
                                        onClick = { this._onToggleContext } />
                                    {this.state.contextOpen
                                        && <FooterContextMenu onMouseLeave = { this._onToggleContext } />}
                                </FooterEllipsisContainer>
                            </Footer>
                        )}
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}

function _mapStateToProps(state): Object {

    return {
    };
}

export default _connect(connect(_mapStateToProps)(RPC_ParticipantsPane));